#!/usr/bin/env node
import { Command } from "commander";
import { registerCatalogCommand } from "./commands/catalog.js";
import { registerCostCommand } from "./commands/cost.js";
import { registerModelsCommand } from "./commands/models.js";
import { readFileSync } from "node:fs";
import { fileURLToPath } from "node:url";
import { dirname, join } from "node:path";

const pkg = JSON.parse(
  readFileSync(join(dirname(fileURLToPath(import.meta.url)), "../../package.json"), "utf8"),
) as { version: string };

const program = new Command();

program
  .name("ai-tools")
  .description("@x12i/ai-tools — AI model catalog, cost calculation, and utilities")
  .version(pkg.version);

registerCatalogCommand(program);
registerModelsCommand(program);
registerCostCommand(program);

program.parseAsync(process.argv).catch((error: unknown) => {
  console.error(error instanceof Error ? error.message : error);
  process.exit(1);
});
